import React, { useEffect } from 'react'
import SignInForm from './SignInForm'
import useAuth from 'utils/hooks/useAuth'
import { Navigate } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google';
import Logo from 'components/template/Logo';
import ReactGA from 'react-ga4';
import TrackingUtils from 'tracking/GoogleTracking';
const SignIn = () => {
    useEffect(() => {
       TrackingUtils.TrackPageView({ hitType: "pageview", 
        page: window.location.pathname ,title:"Sign In"})
      }, []);
    const { authenticated } = useAuth()
    
    if (authenticated) {
        // navigate('/dashboard/default')
        return(
        <Navigate
                to={`/dashboard/default`}
                replace
            />)
    }
    return (
        <><GoogleOAuthProvider clientId="859043692394-f8a2kc0ailbfjpo30lh428v3q7v186jn.apps.googleusercontent.com">
            <div className="mb-8 text-center md:hidden"><Logo mode="dark" imgClass="mx-auto text-center w-[160px]"  /></div>
            <div className="mb-8 text-left md:hidden">
                {/* <span className='text-xl text-uspfred font-bold'>Yes, it's real.</span> */}
            <br></br><span className='text-lg text-uspfblue font-bold'>POD Shirts starting at </span>
            <span className='text-2xl text-uspfred font-extrabold'>$5.99.</span></div>
            <div className="mb-8 text-center">
                <h5 className="mb-1">Welcome back!</h5>
                
            </div>
            <SignInForm disableSubmit={false} />
            </GoogleOAuthProvider>
            <div className='py-4'></div>
            <div className='py-4'></div>
        </>
    )
}

export default SignIn
